import type { StaticTextLookup } from 'src/translators/static-text-lookup';

export const staticTextLookup: Partial<StaticTextLookup> = {}
